import React from "react";
import "react-tabs/style/react-tabs.css";
import { Table } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Badge } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Col } from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import EditIcon from '@material-ui/icons/Create';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { MDBChip } from "mdbreact";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
//import Faq from 'react-faq-component';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

import 'react-accessible-accordion/dist/fancy-example.css';
//import 'react-accessible-accordion/dist/fancy-example.css';
class Faqs extends React.Component {
    state = {};
    constructor(props) {
        super(props);
        this.state = {

        }
        this.handleChange = this.handleChange.bind(this);
        this.hndleAsset = this.handleAsset.bind(this);
        // this.submitHandler = this.submitHandler.bind(this);
    }


    handleChange = event => {
        this.setState({ partnerId: event.target.value });
    };

    handleAsset = () => {
        this.setState({ partnerType: this.state.partnerId });
    };

    nextPath(path) {
        console.log(path);
        this.props.history.push(path);
    }

    onOpeningsChange(e) {
        this.setState({ openings: e });
    }
    handleCloseHere = (param) => (e) => {
        this.setState({
            ['show' + param]: false
        })
    }


    render() {

        return (
            <>
                <div className="kt-wizard-v1__form">
                    <Breadcrumb>
                        <Breadcrumb.Item active>FAQ</Breadcrumb.Item>
                    </Breadcrumb>
                    <Card>
                        <Card.Body>
							<p><b>About GoWatr</b></p>
                            <Accordion>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        {/* <i class="flaticon2-layers-1"></i> */}
                                        <AccordionItemButton>
                                            What is GoWatr?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            GoWatr is a technology platform that enables quick and easy booking
                                            of water tankers all through the year. We are a water delivery company.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton >
                                            How GoWatr will help to solve my Water problem?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            GoWatr has direct access to numerous bore-wells and also operate a large fleet of tankers in varying capacities to deliver water. It’s a hassle-free
                                             process where you don’t need to haggle over payments.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Which are the areas GoWatr provides service?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            Currently, GoWatr services Chennai city and its surrounding areas.
                                            We will be expanding our operations to other cities soon.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>
								<p></p>
								<p><b>Registration and Orders</b></p>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            How do I register myself to book a water tanker?
									</AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            It’s so simple. All you have to do is sign up using your name,
                                            mobile number, email and Voila! you’re all set.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Why registration is necessary?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            This helps us to save your addresses for scheduling the deliveries
                                            and to serve you in a better way.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Can I book multiple orders?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <ul>
                                            <li>   Yes, you can:
            book multiple slots for the same day, </li>
                                            <li>multiple loads on the same slot for different addresses</li>
                                            <li>multiple loads on the same slot for the same address.</li>
                                        </ul>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Can I reschedule my orders?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            Yes, you can reschedule your orders but it has to be done 4 to 6 hours before the delivery schedule.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Can I cancel my orders?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            Yes you can cancel your order and reschedule it for another day.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Are there any cancellation charges?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            Yes, there will be charges for cancellation.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            If I am not available on a specific delivery date, what will happen?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            You can reschedule or cancel the order. You could delegate another person,
                                            at the storage point, to accept the delivery on your behalf on that particular day.
                                              If you are unable to do so, you will be charged the full amount you paid for that tanker.

                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Can I book orders on behalf of others?    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            Yes, you can add multiple addresses and book for others.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Will GoWatr call me before my delivery?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            You will be duly notified.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Will you charge extra for waiting time?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            Yes, additional waiting time is chargeable.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Can I order tankers on public holidays?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            Yes, you can book tankers on public holidays.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            What are the timings of delivery?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            We have different time slots. You can choose one that is convenient for you.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>
								<p></p>
								<p><b>Payment and Rates</b></p>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                           Can I pay cash on delivery (COD)?
										</AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            Yes, COD is available.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            What are my payment options?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            Cash on delivery (COD), online payment and cheques.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Are the rates fixed or variable during seasonal and non-seasonal periods?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            Yes, rates will vary as per season.
                    </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Should I pay any tips to the tanker drivers?
                    </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>
                                            We do not encourage tipping.   </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                {/* <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Tankers are normally delivered late in the night, 
                    this disturb my sleeping time. How the OTS app handle this?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    You can always a point of contact to your address, (i.e., you can give the number of your watchman,
                     so that the lorry guy will call the watchman for delivery instead of calling you)
                    </p>
                </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem> 
                <AccordionItemHeading>
                    <AccordionItemButton>
                    Is the rates are fixed or variable during seasonal and non-seasonal periods? 
                    If so, what is the percentage of variables?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                    Yes, rates and prices will vary as per season. Almost 30-40% will the spike in prices
                     during seasonal periods when compared to non-seasonal periods.
                    </p>
                </AccordionItemPanel>
            </AccordionItem> */}

                            </Accordion>
                        </Card.Body>
                    </Card>
                </div>

            </>
        );
    }
}

export default Faqs;